import { OKXITonConnect } from '@okxconnect/tonsdk';
import { OKXUniversalProvider } from '@okxconnect/universal-provider';
import { createContext } from 'solid-js';
export const ConnectorContext = createContext<OKXITonConnect>();
export const UniversalConnectorContext = createContext<OKXUniversalProvider>();
